module.exports = __webpack_public_path__ + "static/media/infoBtn.1c646527.png";